import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { Card, CardHeader, CardBody, Row, Col, Button, Input, Label, Form, FormGroup, Alert, FormFeedback } from 'reactstrap'
import { ClosableImage, MainLoader } from '../../../../components'
import { validationHelper, normalizeHelper } from '../../../../common/helpers'
import { messages } from '../../../../common/constants'
import { toast } from 'react-toastify'
import { updateEmployee, getEmployee, resetEmployee, resetUpdateEmployee, uploadEmployeePhoto, deleteEmployeePhoto } from '../../../../store/employee/actions'
import { getStores } from '../../../../store/store/actions'
import { getDocumentTypes } from "../../../../store/document-type/actions";
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'
import { FilePond, registerPlugin } from 'react-filepond'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateType);


class EmployeeEdit extends Component {

    constructor(props) {
        super(props)

        this.state = {
            photo: null,
            withCurrentPhoto: false,
            currentPhotoRemoved: false
        }

        this.onSubmit = this.onSubmit.bind(this)
        this.renderStoresField = this.renderStoresField.bind(this)
        this.renderDocumentTypeField = this.renderDocumentTypeField.bind(this)
    }

    async componentDidMount() {
        await this.props.getStores({ reset: true })
        await this.props.getDocumentTypes()
        await this.props.getEmployee(this.props.match.params.id)
    }

    onSubmit(values) {
        this.props.updateEmployee(this.props.match.params.id, values)
    }

    componentDidUpdate(prevProps) {
        this.checkEmployeeFetch(prevProps)
        this.checkEmployeeUpdate(prevProps)
        this.checkUploadEmployeePhoto(prevProps)
        this.checkDeleteEmployeePhoto(prevProps)
    }

    checkEmployeeFetch(prevProps) {
        if (prevProps.initialValues == null && this.props.initialValues != null) {
            const { photoUrl } = this.props.initialValues
            if (photoUrl) this.setState({ withCurrentPhoto: true });
        }
    }

    componentWillUnmount() {
        this.props.resetEmployee();
        this.props.resetUpdateEmployee();
    }

    checkEmployeeUpdate(prevProps) {
        if (prevProps.updatedEmployee == null && this.props.updatedEmployee != null) {
            const { withCurrentPhoto, photo, currentPhotoRemoved } = this.state
            const { id } = this.props.match.params;

            if (!withCurrentPhoto && photo != null) {
                this.props.uploadEmployeePhoto(id, photo);
                return;
            } else if (currentPhotoRemoved && photo == null) {
                this.props.deleteEmployeePhoto(id);
                return;
            }

            this.onSuccess()
        }
    }

    checkUploadEmployeePhoto(prevProps) {
        if (prevProps.uploadedPhoto == null && this.props.uploadedPhoto != null) {
            this.onSuccess()
        }

        if (prevProps.uploadPhotoError == null && this.props.uploadPhotoError != null) {
            this.onSuccess('Sin embargo, no se ha podido guardar la foto.')
        }
    }

    checkDeleteEmployeePhoto(prevProps) {
        if (!prevProps.deletePhotoSuccess && this.props.deletePhotoSuccess) {
            this.onSuccess()
        }
    }

    onSuccess(message = '') {
        let toastMessage = `Empleado actualizado satisfactoriamente. ${message}`
        toast.success(toastMessage)
        this.props.history.push('/administration/employees')
    }

    renderInputField(field) {
        const { meta: { touched, error } } = field
        const hasError = touched && error ? true : false
        const labelClass = field.labelClass ? field.labelClass : 'mt-1'

        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label className={labelClass} >{field.label}</Label>
                </Col>
                <Col xs="12" md="5">
                    <Input {...field.input} invalid={hasError} type={field.type} />
                    {hasError == true ?
                        <FormFeedback>{error}</FormFeedback>
                        : null}
                </Col>
            </FormGroup>
        )
    }

    renderRolesField(field) {
        const { meta: { touched, error } } = field
        const hasError = touched && error ? true : false

        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label htmlFor="select">Género:</Label>
                </Col>
                <Col xs="12" md="5">
                    <Input {...field.input} type="select" invalid={hasError} >
                        <option key={0} value={'0'}>Seleccione...</option>
                        <option key={1} value={'M'}>Masculino</option>
                        <option key={2} value={'F'}>Femenino</option>
                        <option key={3} value={'OTHER'}>Otros</option>
                    </Input>
                    {hasError == true ?
                        <FormFeedback>{error}</FormFeedback>
                        : null}
                </Col>
            </FormGroup>
        )
    }

    renderStoreItems() {
        return this.props.stores.map(store => {
            return (
                <option key={store.id} value={store.id}>{store.name}</option>
            )
        })
    }

    renderStoresField(field) {
        const { meta: { touched, error } } = field
        const hasError = touched && error ? true : false

        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label htmlFor="select">Tienda:</Label>
                </Col>
                <Col xs="12" md="5">
                    <Input {...field.input} type="select" invalid={hasError} >
                        <option key={0} value={0}>Seleccione...</option>
                        {this.renderStoreItems()}
                    </Input>
                    {hasError == true ?
                        <FormFeedback>{error}</FormFeedback>
                        : null}
                </Col>
            </FormGroup>
        )
    }

    renderDocumentTypeField(field) {
        const {
            meta: { touched, error }
        } = field;
        const hasError = touched && error ? true : false;

        return (
            <FormGroup row>
                <Col md="2" lg="1">
                    <Label htmlFor="select">Tipo de Documento *:</Label>
                </Col>
                <Col xs="12" md="5">
                    <Input {...field.input} type="select" invalid={hasError}>
                        <option key={0} value={0}>
                            Seleccione...
                        </option>
                        {this.renderDocumentItems()}
                    </Input>
                    {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
                </Col>
            </FormGroup>
        );
    }

    renderDocumentItems() {
        return this.props.documentTypes.map(document => {
            return (
                <option key={document.id} value={document.id}>
                    {document.name}
                </option>
            );
        });
    }

    renderBirthdayDatePicker({ input, meta: { touched, error } }) {
        const className = touched && error ? 'form-control is-invalid' : 'form-control'
        const hasError = touched && error ? true : false

        return (
            <FormGroup row>
                <Col xs='2' lg='1' >
                    <Label className='mt-2'>Cumpleaños:</Label>
                </Col>
                <Col xs='12' md='5' >
                    <DatePicker
                        selected={input.value ? moment.utc(new Date(input.value), 'DD/MM/YYYY') : null}
                        onChange={input.onChange}
                        className={className}
                        dateFormat={'DD/MM/YYYY'}
                        showYearDropdown
                        showMonthDropdown
                        yearDropdownItemNumber={15}>
                        {hasError == true ?
                            <div style={{ color: 'red' }}>
                                {error}
                            </div>
                            : null}
                    </DatePicker>
                </Col>
            </FormGroup>
        )
    }

    renderInputPhoto() {
        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label>Foto:</Label>
                </Col>
                <Col xs="12" md="5">
                    <FilePond
                        ref={ref => this.pond = ref}
                        labelIdle='Arrastra y Suelta una foto o <span class="filepond--label-action"> Elige </span>'
                        acceptedFileTypes='image/jpeg, image/png'
                        labelFileTypeNotAllowed='Archivo no válido'
                        onupdatefiles={(fileItems) => {
                            if (fileItems.length == 0) return;
                            this.setState({ photo: fileItems[0].file })
                        }}
                        onremovefile={(file) => {
                            this.setState({ photo: null })
                        }}
                    />
                </Col>
            </FormGroup>
        )
    }

    renderEmployeePhoto() {
        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label>Foto:</Label>
                </Col>
                <Col xs="12" md="5">
                    <ClosableImage
                        src={this.props.initialValues.photoUrl}
                        onClose={(e) => {
                            e.preventDefault()
                            this.setState({ withCurrentPhoto: false, currentPhotoRemoved: true });
                        }}
                    />
                </Col>
            </FormGroup >
        )
    }

    render() {

        const { handleSubmit, loading, error, updatedError, updatedLoading, uploadPhotoLoading, deletePhotoLoading, storesLoading, documentTypesLoading } = this.props;
        const isLoadingFetch = (loading || storesLoading || documentTypesLoading);
        const isLoadingSubmit = (updatedLoading || uploadPhotoLoading || deletePhotoLoading);

        if (error) {
            return (
                <Alert color="danger">
                    {error}
                </Alert>
            )
        }
        if (isLoadingFetch) {
            return <MainLoader />
        }
        return (
            <div className='animated'>
                <Card>
                    <CardHeader>
                        Editar Empleado
                    </CardHeader>
                    <CardBody>
                        {
                            updatedError && (
                                <Alert color="danger">
                                    {updatedError}
                                </Alert>
                            )
                        }
                        <Form onSubmit={handleSubmit(handleSubmit(this.onSubmit))} >
                            <Field name='name' label='Nombre:' type='text' component={this.renderInputField} normalize={normalizeHelper.letterOnlyField()} />
                            <Field name='lastname' label='Apellidos:' type='text' component={this.renderInputField} normalize={normalizeHelper.letterOnlyField()} />
                            <Field name="document_type_id" component={this.renderDocumentTypeField} />
                            <Field name='dni' label='DNI:' type='text' component={this.renderInputField} normalize={normalizeHelper.numberOnlyField(8)} />
                            <Field name='birthday' component={this.renderBirthdayDatePicker} /*normalize={normalizeHelper.dateOnlyField()} */ />
                            <Field name='cellphone' label='Teléfono:' type='text' component={this.renderInputField} normalize={normalizeHelper.numberOnlyField(9)} />
                            <Field name='email' label='Email:' type='text' component={this.renderInputField} normalize={normalizeHelper.emailOnlyField()} />
                            <Field name='district' label='Distrito:' type='text' component={this.renderInputField} normalize={normalizeHelper.letterOnlyField()} />
                            <Field name='address' label='Dirección:' type='text' component={this.renderInputField} normalize={normalizeHelper.noSpecialsField()} />
                            <Field name='gender' component={this.renderRolesField} />
                            <Field name='store_id' component={this.renderStoresField} />
                            {
                                this.state.withCurrentPhoto ? this.renderEmployeePhoto() : this.renderInputPhoto()
                            }
                            <Field name='comments' label='Comentarios:' type='textarea' component={this.renderInputField} />

                            <Row>
                                <Col className='mt-3'>
                                    <Button type='submit' disabled={isLoadingSubmit} color='primary' className='mr-2' ><i className="fa fa-save mr-1" /> Guardar</Button>
                                    <Button color='secondary' onClick={() => this.props.history.push('/administration/employees')} ><i className="fa fa-chevron-left mr-1" /> Cancelar</Button>
                                </Col>
                            </Row>

                        </Form>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

function validate(values) {
    const errors = {}

    if (validationHelper.stringIsNullOrEmpty(values.name)) {
        errors.name = messages.MANDATORY_FIELD
    }
    else if (!validationHelper.lettersOnly(values.name)) {
        errors.name = messages.LETTERS_ONLY_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.lastname)) {
        errors.lastname = messages.MANDATORY_FIELD
    }
    else if (!validationHelper.lettersOnly(values.lastname)) {
        errors.lastname = messages.LETTERS_ONLY_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.dni)) {
        errors.dni = messages.MANDATORY_FIELD
    }
    else if (!validationHelper.isNumber(values.dni, 8)) {
        errors.dni = messages.DNI_FORMAT_FIELD
    }

    if (!values.birthday) {
        errors.birthday = messages.MANDATORY_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.cellphone)) {
        errors.cellphone = messages.MANDATORY_FIELD
    }
    else if (!validationHelper.isPhone(values.cellphone)) {
        errors.cellphone = messages.PHONE_FORMAT_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.email)) {
        errors.email = messages.MANDATORY_FIELD
    }
    else if (!validationHelper.isEmail(values.email)) {
        errors.email = messages.EMAIL_FORMAT_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.address)) {
        errors.address = messages.MANDATORY_FIELD
    }
    else if (!validationHelper.noSpecialCharacters(values.address)) {
        errors.address = messages.NO_SPECIAL_CHARACTER_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.district)) {
        errors.district = messages.MANDATORY_FIELD
    }
    else if (!validationHelper.lettersOnly(values.district)) {
        errors.district = messages.LETTERS_ONLY_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.gender) || values.gender == '0') {
        errors.gender = messages.MANDATORY_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.store_id) || values.store_id == '0') {
        errors.store_id = messages.MANDATORY_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.document_type_id) || values.document_type_id == '0') {
        errors.document_type_id = messages.MANDATORY_FIELD
    }

    return errors
}

function mapStateToProps(state) {
    const { employee, loading, error } = state.employee.activeEmployee
    const { updateEmployee, uploadPhoto, deletePhoto } = state.employee

    return {
        initialValues: employee,
        loading,
        error,
        updatedEmployee: updateEmployee.employee,
        updatedError: updateEmployee.error,
        updatedLoading: updateEmployee.loading,

        stores: state.store.storeList.stores,
        storesLoading: state.store.storeList.loading,

        uploadedPhoto: uploadPhoto.photoUrl,
        uploadPhotoLoading: uploadPhoto.loading,
        uploadPhotoError: uploadPhoto.error,

        deletePhotoSuccess: deletePhoto.success,
        deletePhotoLoading: deletePhoto.loading,
        deletePhotoError: deletePhoto.error,

        documentTypes: state.documentType.documentTypeList.documentTypes,
        documentTypesLoading: state.documentType.documentTypeList.loading,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getEmployee,
        updateEmployee,
        getStores,
        resetEmployee,
        resetUpdateEmployee,
        uploadEmployeePhoto,
        deleteEmployeePhoto,
        getDocumentTypes,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'EmployeeEditForm',
    touchOnBlur: false,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    validate
})(EmployeeEdit))




// WEBPACK FOOTER //
// ./src/scenes/Administration/Employee/EmployeeEdit/EmployeeEdit.js